@let main = mainStream();
@let pip = pipStream();
@let issue = problem();
@let cover = overlay();
@if (user(); as user) {
  <!-- A double tap anywhere on the tile toggles the stage (see onTileClick). -->
  <div
    class="video-tile"
    [class.video-tile--speaking]="speaking()"
    [class.video-tile--self]="user.isSelf"
    [class.video-tile--with-pip]="!!pip && mode() === 'main'"
    (click)="onTileClick($event, user)">
    @if (!main.stream) {
      <andor-user-avatar
        [user]="user"
        [scale]="3.0"
        [showStatus]="false"
        [showActivity]="false"></andor-user-avatar>
    } @else if (main.stream | nativeVideo) {
      <canvas
        class="video-tile__media"
        [class.video-tile__media--screen]="main.isScreenShare"
        [andorVideoMount]="main.stream"></canvas>
    } @else {
      <video
        class="video-tile__media"
        [class.video-tile__media--screen]="main.isScreenShare"
        [srcObject]="main.stream"
        autoplay
        playsinline
        disablePictureInPicture
        muted></video>
    }
    <!-- Pinned tiles are too small for a picture-in-picture camera. -->
    @if (pip && mode() === 'main') {
      <div class="video-tile__pip">
        @if (pip | nativeVideo) {
          <canvas class="video-tile__pip-media" [andorVideoMount]="pip"></canvas>
        } @else {
          <video
            class="video-tile__pip-media"
            [srcObject]="pip"
            autoplay
            playsinline
            disablePictureInPicture
            muted></video>
        }
      </div>
    }

    @if (cover) {
      <div class="video-tile__health" role="status">
        <fa-icon class="video-tile__health-icon" [icon]="faVideoSlash"></fa-icon>
        <span class="video-tile__health-title">
          @switch (cover.kind) {
            @case ('no-media') {
              {{ 'No Data From Sender' | translate }}
            }
            @case ('stalled') {
              {{ 'Stream Stalled' | translate }}
            }
            @case ('failed') {
              {{ 'Playback Failed' | translate }}
            }
            @case ('no-capture') {
              {{ 'Video Source Failed' | translate }}
            }
          }
        </span>
        @if (cover.secs !== null) {
          <span class="video-tile__health-hint">
            {{ 'Nothing received for [secs] s' | translate: { secs: cover.secs } }}
          </span>
        }
      </div>
    }

    @if (user.data.hasRaisedHand) {
      <andor-raised-hand-badge class="video-tile__hand"></andor-raised-hand-badge>
    }

    <!-- Clicks on the pills must not count towards the tile's double tap. -->
    <div class="video-tile__corner" (click)="$event.stopPropagation()">
      @if (stageable() || !user.isSelf) {
        <div class="video-tile__actions" [class.video-tile__actions--menu-open]="profileMenuOpen()">
          <!-- Shows this tile large or closes the stage, for this viewer only. -->
          @if (stageable()) {
            @let stageLabel =
              (staged() ? 'Close presentation' : 'Show as presentation') | translate;
            <andor-icon-btn
              class="video-tile__action"
              [tooltip]="stageLabel"
              [aria-label]="stageLabel"
              (click)="stageToggled.emit(user)">
              <fa-icon
                class="video-tile__action-icon"
                [icon]="staged() ? faXmark : faPresentationScreen"></fa-icon>
            </andor-icon-btn>
          }
          @if (!user.isSelf) {
            @if (main.stream) {
              <andor-icon-btn
                class="video-tile__action"
                [tooltip]="'Fullscreen' | translate"
                [aria-label]="'Fullscreen' | translate"
                (click)="fullscreenRequested.emit(user)">
                <fa-icon
                  class="video-tile__action-icon"
                  [icon]="faUpRightAndDownLeftFromCenter"></fa-icon>
              </andor-icon-btn>
            }
            @if (pip) {
              <andor-icon-btn
                class="video-tile__action"
                [tooltip]="'Swap videos' | translate"
                [aria-label]="'Swap videos' | translate"
                (click)="swapStreams(user)">
                <fa-icon class="video-tile__action-icon" [icon]="faRepeat"></fa-icon>
              </andor-icon-btn>
            }
            <andor-icon-btn
              class="video-tile__action"
              [aria-label]="'Participant options' | translate"
              [andorContextMenuTriggerFor]="participantMenu">
              <fa-icon class="video-tile__action-icon" [icon]="faEllipsis"></fa-icon>
            </andor-icon-btn>
          }
        </div>
      }
      @if (issue) {
        <button
          type="button"
          class="video-tile__badge"
          [class.video-tile__badge--error]="issue.health.severity === 'error'"
          [andorTooltip]="issue.label | translate"
          [attr.aria-label]="(issue.label | translate) + ' · ' + ('Show stream stats' | translate)"
          (click)="openStats(issue.kind)">
          <fa-icon class="video-tile__badge-icon" [icon]="faExclamation"></fa-icon>
        </button>
      }
    </div>

    <div class="video-tile__name">
      <andor-mute-status [user]="user"></andor-mute-status>
      @if (user.isFavorite) {
        <fa-icon
          class="video-tile__favorite"
          role="img"
          [icon]="faStar"
          [attr.aria-label]="'Favorite' | translate"></fa-icon>
      }
      <andor-user-name [user]="user"></andor-user-name>
    </div>
  </div>
  <andor-context-menu
    #participantMenu
    xPosition="before"
    yPosition="below"
    (opened)="profileMenuOpen.set(true)"
    (closed)="profileMenuOpen.set(false)">
    <andor-participant-mini-profile [user]="user"></andor-participant-mini-profile>
  </andor-context-menu>
}
